
export default {
  setProperties(state, data) {
    state.properties = [];
    state.properties = [...data];
    state.charmSubscribedProperties = [];
    state.charmSubscribedProperties = state.properties.length ? state.properties.filter(p => p.mini_charm_enabled === true) : [];
    if (state.charmSubscribedProperties.length && state.filteredProperties.length) {
      state.charmSubscribedAndFilteredProperties = state.charmSubscribedProperties?.filter(f => state.filteredProperties?.some(s => s === f.property_id)) || [];
    }
  },

  setFilteredProperties(state, data) {
    state.filteredProperties = [];
    state.filteredProperties = [...data];
    if (state.charmSubscribedProperties.length && state.filteredProperties.length) {
      state.charmSubscribedAndFilteredProperties = state.charmSubscribedProperties?.filter(f => state.filteredProperties?.some(s => s === f.property_id)) || [];
      state.charmSubscribedNotSelectedProperties = state.charmSubscribedProperties?.filter(f => !state.filteredProperties?.some(s => s === f.property_id)) || [];      
    }
  },

  setUserDetails(state, payload) {
    state.userDetails = payload;
  },

  setCharmUsers(state, payload) {
    state.charmUsers = payload
  },

  setAgentgroups(state,payload){
    state.agentgroups = payload
  },

  setAgentGroupsIvrFlow(state,payload){
    state.agentGroupsIvrFlow = payload
  },

  setRingTime(state, payload){
     const updatedRingTimeData = { ...state.ringTime };

    if (payload.corporate) {
      updatedRingTimeData.corporate = payload.corporate;
    }

    if (payload.property && Object.keys(payload.property).length > 0) {
      updatedRingTimeData.property = payload.property;
    }

    state.ringTime = updatedRingTimeData;
  }

};
